import { getNextSortConfig } from "./dailySaleReportTableConfig";

export { getNextSortConfig };

// indexed like postaxregisterreport_head; amounts sort on the raw numbers the API sends
export const TAX_REGISTER_COLUMN_FIELDS = [
  null,
  "createdAt",
  "doc_type",
  "ref",
  "description",
  "qty",
  "before_tax",
  "tax",
  "amount",
  "remark",
  "user",
];

const TAX_REGISTER_NUMERIC_FIELDS = new Set(["qty", "before_tax", "tax", "amount"]);

const getSortValue = (row, field, numericFields) => {
  const value = row?.[field];
  if (value === null || value === undefined || value === "") return null;
  if (field === "createdAt") {
    const time = new Date(value).getTime();
    return Number.isFinite(time) ? time : null;
  }
  if (numericFields.has(field)) {
    const num = Number(value);
    return Number.isFinite(num) ? num : null;
  }
  return String(value).toLowerCase();
};

const compareValues = (left, right) => {
  if (left === null && right === null) return 0;
  if (left === null) return 1;
  if (right === null) return -1;
  if (typeof left === "number" && typeof right === "number") return left - right;
  return String(left).localeCompare(String(right), undefined, {
    sensitivity: "base",
    numeric: true,
  });
};

// generic column sort for POS reports: `fields` is indexed like the table head (null = not sortable)
export const sortReportRows = (rows, sortConfig, fields, numericFields) => {
  if (!Array.isArray(rows) || !rows.length) return rows || [];
  const field = fields[sortConfig?.columnIndex];
  if (!field) return rows;
  const direction = sortConfig.direction === "desc" ? -1 : 1;
  return [...rows].sort(
    (rowA, rowB) =>
      compareValues(getSortValue(rowA, field, numericFields), getSortValue(rowB, field, numericFields)) *
      direction
  );
};

export const sortTaxRegisterRows = (rows, sortConfig) =>
  sortReportRows(rows, sortConfig, TAX_REGISTER_COLUMN_FIELDS, TAX_REGISTER_NUMERIC_FIELDS);
